import React from "react";
import styles from "../styles/heroSection.module.css";

const HeroSection = () => {
  const handleResumeView = () => {
    const driveLink =
      "https://drive.google.com/file/d/15C3bM-h_tyfOEujzz3CgjPahkxA2wvs0/view";
    window.open(driveLink, "_blank");
  };

  return (
    <div className={styles.heroSection}>
      <div className={styles.heroSectionLeft}>
        <span
          style={{ marginLeft: "10px", fontSize: "1.3rem", color: "#84e1cd" }}
        >
          Hi there, I'm
        </span>
        <h1>Amit Rai</h1>
        <p>
          I'm a full-stack developer specializing in building and designing web
          apps using the MERN stack. My expertise includes developing scalable,
          customized, and responsive web applications.
        </p>
        <button onClick={handleResumeView} className={styles.customBtn}>
          VIEW RESUME
        </button>
      </div>
      <div className={styles.heroSectionRight}>
        <iframe
          title="Animation"
          style={{ border: "none", width: "25rem", height: "25rem" }}
          src="https://lottie.host/embed/d0584536-e36c-4fb3-9afe-1a7c8cf9301d/f73IC1aXHL.json"
        ></iframe>
      </div>
    </div>
  );
};

export default HeroSection;
